var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.989 511.989",
    style: {
      enableBackground: "new 0 0 511.989 511.989"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#27536B"
    },
    cx: 255.994,
    cy: 255.994,
    r: 255.994
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD57E"
    },
    d: "M391.37,292.817c-48.362,48.362-126.774,48.362-175.136,0s-48.362-126.774,0-175.136 c10.084-10.084,21.476-18.057,33.627-23.935c-39.798,1.061-79.279,16.774-109.653,47.147c-62.946,62.946-62.946,165.003,0,227.949 s165.003,62.946,227.949,0c30.374-30.374,46.086-69.854,47.147-109.653C409.427,271.341,401.454,282.733,391.37,292.817z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "355.804,153.568 361.513,205.217 367.224,153.568 418.873,147.859 367.224,142.148  361.513,90.499 355.804,142.148 304.154,147.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "112.365,410.626 116.455,447.623 120.545,410.626 157.542,406.536 120.545,402.446  116.455,365.449 112.365,402.446 75.368,406.536  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.188,
    y: 248.208,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.4278 249.8396)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.93,
    y: 193.377,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.1825 358.0481)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.017,
    y: 284.419,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -71.4537 406.696)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.067,
    y: 124.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.9259 95.4443)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.322,
    y: 421.433,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -198.7088 373.5025)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.587,
    y: 97.883,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -36.9191 116.9972)",
    style: {
      fill: "#FFFFFF"
    },
    width: 10.362,
    height: 10.362
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.aa81408aaa2ea3da549cd0a09ef49bbd.svg";
export { ForwardRef as ReactComponent };